export const FulfillmentOptionTagMap = {
    BUNDLED: 'BUNDLED',
};
export const CheckoutEndpoint = (makeRequest) => {
    return {
        fetchFulfillmentOptions(params, options) {
            return makeRequest('POST', '/v1/checkout/fulfillment_options', params, options);
        },
        fetchFulfillmentWindowOptions(params, options) {
            return makeRequest('POST', '/v1/checkout/fulfillment_window_options', params, options);
        },
    };
};
//# sourceMappingURL=checkout_endpoint.js.map